import styled from "styled-components";
import IconPreloader from "./icon-preloader.gif"
import AiBackground from "./ai-background.png";
import AiIcon from "./ai-icon.png";

export const ElementQuizContainer = styled.div`
  padding-top: 30px;
  padding-bottom: 30px;
  overflow: hidden;
  position: relative;

  /*SM*/
  &.max-w-sm .rdp-element-quiz__quiz-card  {
    max-width: 760px;
  }
  /*MD*/
  &.max-w-md .rdp-element-quiz__quiz-card  {
    max-width: 1160px;
  }
  /*LG*/
  &.max-w-lg .rdp-element-quiz__quiz-card  {
    max-width: 1600px;
  }
  /*FULL*/
  &.max-w-full .rdp-element-quiz__quiz-card  {
    max-width: calc(100% - 60px);
  }

  .rdp-react-quiz-6-result-preloader {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto;
    background-image: url(${IconPreloader});
    background-size: 180px;
    background-position: center;
  }

  .rdp-react-quiz-6-result-ai {
    padding: 30px;
    border-radius: 10px;
    color: #000;
    background-image: url(${AiBackground});
    background-size: cover;
    background-position: center;
  }

  .rdp-react-quiz-6-result-ai-icon {
    width: 50px;
    height: 50px;
    display: block;
    margin: 0 auto 20px;
    background-image: url(${AiIcon});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .rdp-react-quiz-6-result-ai-message {
    color: #6b6b6b;
    font-size: 20px;
    font-weight: 1000;
    font-family: Lato-Bold;
    display: block;
    text-align: center;
    line-height: 1.5;
  }
`;